import moment from 'moment'
import uniqWith from 'lodash/unionWith'
import isEqual from 'lodash/isEqual'

const localState = {
    data: {},
    dialogs: [],
    rawMessages: [],
    messages: [],
    typeDialogs: '',
    currentDialog: '',
    socketDialogId: null,
    companion: {
        name: '',
        image: '',
    },
    isGettingOld: false,
    isLastMessages: false,
    dialogId: null,
    isliveUpdate: false,
    dialogUsername: null,
}

const mutations = {
    FILTER_DIALOGS(state, dialogs) {
        state.dialogs = JSON.parse(JSON.stringify(dialogs))
    },
    FILTER_MESSAGE(state, messages) {
        let data = JSON.parse(JSON.stringify(messages))
        data = uniqWith(data, isEqual)

        const result = []
        let author = ''
        let time = ''
        let timeOut = ''
        let date = ''
        const timeLimit = 30000 // Группировать сообщения с разницей во времени до 30 секунд.
        data.sort((a, b) => (Number(a.datetime) < Number(b.datetime) ? -1 : 1))
        data.forEach((current) => {
            current.messages = []
            current.dialogDate = ''
            const diffTime = current.datetime - timeOut
            if (author === current.author && diffTime < timeLimit) {
                result.forEach((element) => {
                    if (
                        element.author === author
						&& Number(element.datetime) === Number(time)
                    ) {
                        element.messages.push({
                            text: current.content,
                            type: current.type,
                        })
                        const messageDate = moment(element.datetime).format(
                            'DD.MM.YYYY',
                        )
                        if (date !== messageDate) {
                            current.dialogDate = messageDate
                            date = messageDate
                        }
                        timeOut = +current.datetime
                    }
                })
            } else {
                current.messages.push({
                    text: current.content,
                    type: current.type,
                })
                result.push(current)
                time = +current.datetime
                timeOut = +current.datetime
                const messageDate = moment(current.datetime).format('DD.MM.YYYY')
                if (date !== messageDate) {
                    current.dialogDate = messageDate
                    date = messageDate
                }
            }
            author = current.author
        })

        state.messages = result
    },

    CLEAR_MESSAGES(state) {
        state.messages = []
    },
    RESET_COUNT_MESSAGE_DIALOGS(state, id) {
        state.dialogs.forEach((element) => {
            if (element.id === id) {
                element.unread_count = 0
            }
        })
    },
    SET_COMPANION_DATA(state, dialogId) {
        state.dialogs.forEach((element) => {
            if (element.id === dialogId) {
                state.companion = element.companion
            }
        })
    },
    RESET_CURRENT_DIALOG(state) {
        state.currentDialog = ''
    },
    setDialogId: (state, v) => {
        state.dialogId = v
    },
    setCompanion: (state, v) => {
        state.companion = v
    },
    setSocketDialogId: (state, v) => {
        state.socketDialogId = v
    },
    setIsliveUpdate: (state, v) => {
        state.isliveUpdate = v
    },
    setDialogUsername: (state, v) => {
        state.dialogUsername = v
    },
}

const actions = {
    async getDialogs({
        state,
        commit,
    }, type) {
        try {
            state.typeDialogs = type
            state.dialogs = []

            const response = await this.$api.chat.fetch(type)

            commit('FILTER_DIALOGS', response.data.dialogs)
            return state.data
        } catch (err) {
            console.log(err)
        }
    },
    async getDialog({
        state,
        commit,
    }, {
        type,
        dialogId,
    }) {
        try {
            state.messages = []
            state.rawMessages = []
            state.typeDialogs = type
            state.currentDialog = dialogId
            state.isGettingOld = false
            state.isLastMessages = false
            state.isliveUpdate = false

            commit('SET_COMPANION_DATA', dialogId)
            const response = await this.$api.chat.fetchById({
                type,
                id: dialogId,
            })
            state.rawMessages = [...response.data.messages]
            state.messages = [...response.data.messages]
            state.messages.forEach((element) => {
                element.datetime *= 1000
            })

            commit('FILTER_MESSAGE', state.messages)
            commit('RESET_COUNT_MESSAGE_DIALOGS', dialogId)
            commit('FILTER_DIALOGS', state.dialogs)
            commit('setDialogId', dialogId)

            return state.data
        } catch (err) {
            console.log(err)
        }
    },
    async getOldMessages({
        state,
        commit,
    }, {
        type,
        dialogId,
    }) {
        try {
            const messageId = state.rawMessages[0].id
            const response = await this.$api.chat.fetchPrev({
                type,
                id: dialogId,
                messageId,
            })

            if (response.data.messages.length === 0) {
                state.isLastMessages = true
            }

            response.data.messages.forEach((element) => {
                element.datetime *= 1000
            })

            state.rawMessages = response.data.messages.concat(
                state.rawMessages,
            )

            commit('FILTER_MESSAGE', state.rawMessages)

            return state.data
        } catch (err) {
            console.log(err)
        }
    },

    async sendMessageToAll({
        dispatch,
    }, {
        message,
    }) {
        try {
            const now = Date.now()
            dispatch('SendLocalMessage', {
                author: 'self',
                content: message,
                datetime: now,
                id: 'all',
                type: 'text',
                last_mess: true,
            })
            dispatch('updateDialigListMessage', {
                dialog_id: 'all',
                content: message,
                datetime: now,
                type: 'text',
            })
            await this.$api.chat.sentToAll({
                message,
            })
        } catch (err) {
            console.log(err)
        }
    },

    async sendMessage({
        state,
        dispatch,
    }, {
        type,
        dialogId,
        message,
    }) {
        try {
            const now = Date.now()
            dispatch('SendLocalMessage', {
                author: 'self',
                content: message,
                datetime: now,
                id: dialogId,
                type: 'text',
                last_mess: true,
            })
            dispatch('updateDialigListMessage', {
                dialog_id: state.currentDialog,
                content: message,
                datetime: now,
                type: 'text',
            })

            await this.$api.chat.send({
                type,
                id: dialogId,
            }, {
                message,
            })
        } catch (err) {
            console.log(err)
        }
    },
    SendLocalMessage({
        state,
        commit,
    }, newMessage) {
        state.rawMessages.push(newMessage)
        commit('FILTER_MESSAGE', state.rawMessages)
    },

    soketMessage({
        state,
        dispatch,
    }, data) {
        const now = Date.now()
        if (data.dialog_id === state.currentDialog) {
            const newMessage = {
                author: 'companion',
                content: data.content,
                datetime: now,
                id: data.id,
                type: data.type,
            }

            dispatch('SendLocalMessage', newMessage)
        }
        dispatch('updateDialigListMessage', {
            dialog_id: data.dialog_id,
            content: data.content,
            datetime: now,
            type: data.type,
        })
    },

    async sendMedia({
        state,
        dispatch,
    }, {
        type,
        dialogId,
        media,
        media64,
    }) {
        try {
            const now = Date.now()
            dispatch('SendLocalMessage', {
                author: 'self',
                content: media64,
                datetime: now,
                id: dialogId,
                type: 'image',
                last_mess: true,
            })
            dispatch('updateDialigListMessage', {
                dialog_id: state.currentDialog,
                content: 'media',
                datetime: now,
                type: 'image',
            })

            await this.$api.chat.sendMedia({
                type,
                id: dialogId,
            }, media)
        } catch (err) {
            console.log(err)
        }
    },
    async sendMediaToAll({
        dispatch,
    }, {
        media,
        media64,
    }) {
        try {
            const now = Date.now()
            dispatch('SendLocalMessage', {
                author: 'self',
                content: media64,
                datetime: now,
                id: 'all',
                type: 'image',
                last_mess: true,
            })
            dispatch('updateDialigListMessage', {
                dialog_id: 'all',
                content: 'media',
                datetime: now,
                type: 'image',
            })

            await this.$api.chat.sendMediaToAll(media)
        } catch (err) {
            console.log(err)
        }
    },
    updateLocalMessage({
        state,
        commit,
    }, data) {
        state.rawMessages.forEach((element) => {
            if (element.last_mess) {
                element.datetime = data.datetime
            }
        })
        commit('FILTER_MESSAGE', state.rawMessages)
    },
    updateDialigListMessage({
        state,
        commit,
    }, data) {
        state.dialogs.forEach((element) => {
            if (element.id === data.dialog_id) {
                element.last_message = {
                    content: data.content,
                    datetime: data.datetime,
                    type: data.type,
                }
                if (
                    data.dialog_id === state.currentDialog
					&& state.isGettingOld === true
                ) {
                    element.unread_count += 1
                } else if (data.dialog_id !== state.currentDialog) {
                    element.unread_count += 1
                } else {
                    element.unread_count = 0
                }
            }
        })
        commit('FILTER_DIALOGS', state.dialogs)
    },
    clearMessagesList({
        commit,
    }) {
        commit('CLEAR_MESSAGES')
    },
    changeMessage({
        state,
        commit,
    }, data) {
        state.rawMessages.forEach((element) => {
            if (element.id === data.id) {
                element.content = data.content
            }
        })
        commit('FILTER_MESSAGE', state.rawMessages)
    },
    deleteLocalMessage({
        state,
        commit,
    }, data) {
        state.rawMessages.forEach((element, i) => {
            if (element.id === data.id) {
                state.rawMessages.splice(i, 1)
            }
        })
        commit('FILTER_MESSAGE', state.rawMessages)
    },
}

const getters = {
    messagesGetters: (state) => state.messages,
    companionNameGetters: (state) => state.companion.name,
    companionPhotoGetters: (state) => state.companion.image,
    isLastMessagesGetters: (state) => state.isLastMessages,

    dialogIdGetters: (state) => state.dialogId,
    typeDialogsGetters: (state) => state.typeDialogs,
    currentDialogGetters: (state) => state.currentDialog,
    socketDialogIdGetters: (state) => state.socketDialogId,
    isliveUpdate: (state) => state.isliveUpdate,
    dialogUsername: (state) => state.dialogUsername,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
